import { combineReducers } from "redux";
import user from "./user";
import spinner from "./spinner";
import pageContent from "./pageContent";

export default combineReducers({
  user,
  spinner,
  pageContent
});